/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  's_package': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 7h-1.26A3 3 0 0 0 19 6a3 3 0 0 0-3-3 3.8 3.8 0 0 0-1.82.63L12 6.16 8.82 3.63A3.8 3.8 0 0 0 7 3a3 3 0 0 0-3 3c0 .4.12.77.26 1H4a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1h1v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9h1a1 1 0 0 0 1-1V9a2 2 0 0 0-2-2zM17 4a1 1 0 0 1 0 2h-2.19l1.31-1.4A1 1 0 0 1 17 4zM6 4a1 1 0 0 1 .68.18L8.19 6H6a1 1 0 0 1 0-2zM4 9h7v7H4zm9 7V9h7v7z"/>'
  }
})
